"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styleUtilities = require("@creditas-lab/style-utilities");

var _stylitas = require("@creditas/stylitas");

var Container = _stylitas.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  box-sizing: border-box;\n  padding: 16px 20px 12px 20px;\n\n  ", "\n"])), _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 32px 32px 32px 48px;\n  "]))));

exports.Container = Container;